import '../style/index.sass'
import '../style/about.sass'

// const bg = require('../assets/about.jpg')
const itsAMe = require('../assets/me.png')
const itsAMeGif = require('../assets/me.gif')

export default function About() {
    return (
        <section id='about'>
            <div className="about">
                <div className="gridTwo">
                    <section id='textcontent'>
                        <h2>In a nutshell</h2>
                        <p style={{'textAlign':'center', 'textDecoration': 'underline gray'}}>I'm a 22 year-old <strong>Webdeveloper</strong> based in Norway.</p>
                        
                        <p>Just graduated from NTNU Gjøvik with a <strong>Bachelor's in web development</strong>, and I'm really looking forward to using the skills and knowledge I've gotten over these past years. I consider myself either a front-end or <strong>fullstack developer</strong>, of course being an entry-level on both. I have plans on building up my knowledge arsenal, though working on my current skills, as well as exploring new aspects, such as frameworks, libraries, programming languages, etc. Currently, I'm building up my knowledge of <strong>C# and .NET.</strong></p>
                        <p>Looking away from web development, I love making art (characters, mostly), take pictures and videos with my drone, and I am going to teach myself how to box properly. Well, YouTube will teach me.</p>
                        <p>If you want to, you can have a look at some of the projects I've completed further down, or check out my galleries of art and drone shot photos. Anyhow-</p>
                        <h2>Have a nice day :))</h2>
                    </section>
                    {/* <section id="portrait">
                        <div className="me">
                            <img className='png' src={itsAMe} alt="A portrait of me, the creator of the page" />
                            <img className='gif' src={itsAMeGif} alt="A glitching animation portrait of me, the creator of the page" />
                        </div>
                        <div className='skills'>
                            <h3>Tech Skills</h3>
                            <ul>
                                <li>Javascript</li>
                                <li>React.js</li>
                                <li>HTML & CSS</li>
                                <li>MERN Stack</li>
                                <li>Stripe.js basics</li>
                            </ul>
                        </div>
                        <div className="toCV">
                            <a target="_blank" rel="noopener noreferrer" href="https://drive.google.com/file/d/1RG5jzoMMoawsLIYJJ9HPYj49DD1so85l/view?usp=sharing">My CV</a>
                        </div>
                    </section> */}
                    <div className="toCV">
                        <a target="_blank" rel="noopener noreferrer" href="https://drive.google.com/file/d/1RG5jzoMMoawsLIYJJ9HPYj49DD1so85l/view?usp=sharing">My CV</a>
                    </div>
                </div>
            </div>
        </section>
    )
}